(function() {
  var ENDPOINT = 'https://ops.skinslegend.com/api/behavior/rum';
  var buffer = {};
  var sent = false;

  // Detect page type from Shopify template
  var pageType = '{{ template.name | default: "other" }}';

  // Detect device type
  var isMobile = /Mobi|Android/i.test(navigator.userAgent);
  var deviceType = isMobile ? 'mobile' : 'desktop';

  // Connection type
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var connectionType = conn ? (conn.effectiveType || conn.type || 'unknown') : 'unknown';

  // Session/visitor IDs (reuse from sl-tracker if available)
  var sessionId = (typeof window.__slSessionId !== 'undefined') ? window.__slSessionId : '';
  var visitorId = (typeof window.__slVisitorId !== 'undefined') ? window.__slVisitorId : '';

  function sendMetrics() {
    if (sent || Object.keys(buffer).length === 0) return;
    sent = true;

    var payload = {
      url: location.href,
      page_type: pageType,
      device_type: deviceType,
      connection_type: connectionType,
      session_id: sessionId,
      visitor_id: visitorId
    };

    // Merge buffered metrics
    for (var k in buffer) {
      payload[k] = buffer[k];
    }

    // Use sendBeacon for reliable delivery on page unload
    if (navigator.sendBeacon) {
      navigator.sendBeacon(ENDPOINT, JSON.stringify(payload));
    } else {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', ENDPOINT, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify(payload));
    }
  }

  function onMetric(metric) {
    buffer[metric.name.toLowerCase()] = Math.round(metric.value * 1000) / 1000;

    // Send after we have at least LCP (the last metric to fire on most pages)
    if (buffer.lcp) {
      // Small delay to collect any remaining metrics
      setTimeout(sendMetrics, 1000);
    }
  }

  // Load web-vitals from CDN (unpkg, ~2KB gzipped)
  var script = document.createElement('script');
  script.src = 'https://unpkg.com/web-vitals@4/dist/web-vitals.iife.js';
  script.async = true;
  script.onload = function() {
    if (window.webVitals) {
      window.webVitals.onCLS(onMetric);
      window.webVitals.onFCP(onMetric);
      window.webVitals.onINP(onMetric);
      window.webVitals.onLCP(onMetric);
      window.webVitals.onTTFB(onMetric);
    }
  };
  document.head.appendChild(script);

  // Fallback: send whatever we have on page unload
  addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'hidden') sendMetrics();
  });
})();